module.exports = __webpack_public_path__ + "static/media/import.22e839ba.svg";